export default __webpack_public_path__ + "static/media/avatar.7fb913b9.svg";